import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const fromDtoToSalonVat = (dto) => ({
  // NOTE: it can also be checked like this
  // isVatRegistered: fromAnyToBool(dto?._v === 1 ? dto?.results?.is_vat_registered : dto?.is_vat_registered),
  isVatRegistered: fromAnyToBool(dto?.is_vat_registered ?? dto?.results?.is_vat_registered),
  vatNumber: dto?.results?.vat_number,
});

export default fromDtoToSalonVat;
